import { render } from "./ModalSlider.vue?vue&type=template&id=3754b288"
import script from "./ModalSlider.vue?vue&type=script&lang=js"
export * from "./ModalSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__